module.exports = __webpack_public_path__ + "img/V-63-ER-1000-N.e432917a.png";